import {h, Component} from 'preact'
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import constants from "../constants";
import {
  AlignLeftOutlined,
  AlignCenterOutlined,
  AlignRightOutlined,
  DownOutlined,
} from "@ant-design/icons";

export default @connect(reduce, actions)
class TextAlignWidget extends Component {
  constructor() {
    super()
  }

  render(props, state) {
    return (
      <div className="dropdown">
        <a tabindex="0" className={'dropdown-toggle icn saf-stop' + (props.disabled === true ? ' disabled' : '') + (props.isMobileVersion ? ' mobile-tool-widget' : '')}>
          { props.align == 'left' && <AlignLeftOutlined /> }
          { props.align == 'center' && <AlignCenterOutlined /> }
          { props.align == 'right' && <AlignRightOutlined /> }
          {props.isMobileVersion && <span>Alignment</span>}
        </a>

        <div className="dropdown-menu aligns text-aligns saf-stop" data-close="no">
          {props.isMobileVersion && <div className="mobile-dropdown-header">
            <span>Alignment</span>
            <div className="dropdown-toggle"><DownOutlined/></div>
          </div>}
          <div className="angle left" />
          <ul>
            <li>
              <a onClick={() => props.onAlign('left')}>
                <AlignLeftOutlined />
                {props.isMobileVersion && <span>Left</span>}
              </a>
            </li>
            <li>
              <a onClick={() => props.onAlign('center')}>
                <AlignCenterOutlined />
                {props.isMobileVersion && <span>Center</span>}
              </a>
            </li>
            <li>
              <a onClick={() => props.onAlign('right')}>
                <AlignRightOutlined />
                {props.isMobileVersion && <span>Right</span>}
              </a>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}
